import React, { useContext } from "react";
import { useState } from "react";
import validator from "validator";
import AuthContext from "../../store/auth-context";
import { Link } from "react-router-dom";
import CartInputField from "../Cart/CartInputField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import OkPopup from "../OkPopup";

const LoginEmail = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [OutcomeMessage, setOutcomeMessage] = useState("");
  const [netError, setNetError] = useState(null);
  const closeAddedDialog = () => {
    setShowDialog(false);
  };

  // per login simulato durante i test
  // const [mail, setMail] = useState("elettra.d@email.it");
  //  const [password, setPassword] = useState("testpsw");

  const [formMail, setFormMail] = useState("");
  const [formPassword, setFormPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [errorList, setErrorList] = useState([]);

  const mailHandler = (event) => {
    setFormMail(event.target.value.trim());
  };

  const mailValidator = (event) => {
    if (validator.isEmail(event.target.value)) {
      setEmailError("");
    } else {
      setEmailError("Email non valida!");
    }
  };
  const passwordHandler = (event) => {
    setFormPassword(event.target.value);
  };

  function checkTextValue(txt, fieldName, special = "") {
    if (txt.trim().length === 0) {
      return "Si prega di non lasciare il campo vuoto.";
    }
    switch (special) {
      case "phone":
        if (!txt.match(/^[0-9\s(+)-]*$/)) {
          return "Inserire un numero di telefono valido.";
        }
        if (txt.length < 8) {
          return "Numero troppo corto.";
        }
        break;
      case "email":
        if (!validator.isEmail(txt)) {
          return "Inserire un indirizzo di email valido.";
        }
        break;
      case "cap":
        if (!validator.isPostalCode(txt, "IT")) {
          return "Inserire un CAP valido.";
        }
        break;
    }
    return "";
  }

  function loginRequest() {
    let params = [
      { name: "id_sessione", value: props.sessionKey },
      { name: "mail", value: formMail },
      { name: "password", value: formPassword },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/login",
      isLoading,
      setIsLoading,
      netError,
      (errMsg) => {
        if (errMsg) {
          //console.log(errMsg);
          //setNetError(errMsg);
          setOutcomeMessage("Accesso fallito. Verifica l'indirizzo email e la password, per favore.");
          setShowDialog(true);
        }
      },
      params,
      (respData) => {
        //console.log(respData);
        if (Array.isArray(respData)) {
          props.userUpdate(respData[0]);
        } else {
          setOutcomeMessage(respData.message);
          setShowDialog(true);
        }
        setIsLoading(false);
      }
    );
  }


  return (
    <div>
      {showDialog === true ? (
        <OkPopup
          titletext="Errore!"
          text={OutcomeMessage}
          closeHandler={closeAddedDialog}
        />
      ) : null}
      <div>
        <CartInputField
          required={true}
          type="email"
          lbl="Email"
          name="Email"
          value={formMail}
          change={setFormMail}
          cssClass="riga_info_cart"
          errList={errorList}
        />
        <CartInputField
          required={true}
          type="password"
          lbl="Password"
          name="LoginPassword"
          value={formPassword}
          change={setFormPassword}
          cssClass="riga_info_cart"
          errList={errorList}
        />        
        <input
            className="accedi-login"
            type="button"
            value="Accedi"
            onClick={loginRequest}
        />
        <p>
          Non ricordi la password? Clicca{" "}
          <Link to="/recupero-password">qui</Link>
        </p>
        
      </div>
    </div>
  );
};
export default LoginEmail;
